module.exports = __webpack_public_path__ + "static/media/watch-maker.52665c7b.png";